import React from 'react'
import { Pagination as AntdPagination } from 'antd'
import { useLingui } from '@lingui/react/macro'

import styles from './index.module.scss'

import type { PaginationProps } from 'antd'


import { cls } from 'tagged-classnames-free';
export interface TadPaginationProps extends PaginationProps {}

const TadPagination: React.FC<TadPaginationProps> = (props) => {
  const { className, locale, size = 'small', ...restProps } = props
  const { t } = useLingui()

  return (
    <AntdPagination
      {...restProps}
      size={size}
      className={cls`${styles.pagination} ${className || ''}`}
      itemRender={(_, type, originalElement) => {
        if (type === 'prev' || type === 'next') {
          return (
            <div
              className={cls`
                text-f-text-quaternary
                hover:text-f-text-secondary
                flex size-full items-center justify-center
                [&[disabled]]:pointer-events-none
              `}
            >
              <span
                className={cls`${type === 'prev' ? 'i-cus--tad-left' : 'i-cus--tad-right'} size-[18px]`}
              />
            </div>
          )
        }

        return originalElement
      }}
      locale={{
        jump_to: t`Go to`,
        page: t`Page`,
        items_per_page: t`/ page`,
        ...locale,
      }}
    />
  )
}

export default TadPagination
